import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChatBubbleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChatBubbleSVG;
